// Libraries
import React from 'react';
import PropTypes from 'prop-types';

// Components
import SearchInput from 'src/components/search/search-input';
import {SearchIcon} from 'src/components/SharedComponents/icons/search-icon';

export class SearchInputContainer extends React.Component {

    render() {
        const mobileSearchIconProps = {
            color: this.props.searchContainerColor,
            iconClassNames: this.props.mobileSearchIconClassNames,
            onClickHandler: this.props.showSearchInputOverlay
        };
        const tabletSearchIconProps = {
            color: this.props.searchContainerColor,
            iconClassNames: this.props.tabletSearchIconClassNames,
            onClickHandler: this.props.showSearchInputOverlay
        };
        const desktopSearchInputProps = {
            color: this.props.searchContainerColor,
            textInputValue: this.props.searchQuery,
            searchIconClassNames: this.props.desktopSearchIconClassNames
        };
        return (<div className="search-input-container">
            <div className="search-input-container-desktop"><SearchInput {...desktopSearchInputProps} /></div>
            <div className="search-input-container-tablet"><SearchIcon {...tabletSearchIconProps} /></div>
            <div className="search-input-container-mobile"><SearchIcon {...mobileSearchIconProps} /></div>
        </div>);
    }
}
SearchInputContainer.propTypes = {
    searchContainerColor: PropTypes.string,
    searchQuery: PropTypes.string,
    showSearchInputOverlay: PropTypes.func,
    desktopSearchIconClassNames: PropTypes.string,
    tabletSearchIconClassNames: PropTypes.string,
    mobileSearchIconClassNames: PropTypes.string
};




// WEBPACK FOOTER //
// ./src/components/search/search-input-container.js